module.exports = __webpack_public_path__ + "img/client4.6a529f8b.png";